<div
  *ngIf="loading"
  class="loading_box"
  [@fadeOut]="fadeOut ? 'visible' : 'hidden'"
></div>
<div *ngIf="!loading" id="wrapper">
  <!--header-->
  <div id="header">
    <div class="inner-width">
      <div class="logo">
        <img src="../../../assets/images/EHRlogo.svg" alt="" /><span class="version-number">{{ appVersion }}</span>
      </div>
      <div class="nav">POC版本</div>
      <button class="btn btn-primary small-btn" (click)="logout()">登出</button>
      
    </div>
  </div>
  <!--header end-->
  
  <!-- 常駐右側伺服器狀態顯示區 -->
  <div
    class="server-status-box"
    [ngClass]="{ 'ok': serverStatusOk, 'error': !serverStatusOk }"
    *ngIf="serverStatusMessage"
  >
    {{ serverStatusMessage }}
  </div>
  <!--content-->
  <div id="content">
    <div class="inner-width">
      <div class="inndex_box mb-3" *ngIf="detail == false">
        <div class="btns">
          <input
            type="file"
            id="file-upload"
            name="filename"
            (change)="onFileSelected($event)"
          />
          <div class="upload_text" *ngIf="upload === 1">{{ fileName }}</div>
          <label
            for="file-upload"
            *ngIf="upload === 0"
            class="btn btn-primary wd-120 upload_btn"
            ><i class="fa fa-plus" aria-hidden="true"></i
            ><span>選擇檔案</span></label
          >
          <label
            for="file-upload"
            *ngIf="upload === 2"
            class="btn btn-primary wd-120 upload_btn"
            ><i class="fa fa-plus" aria-hidden="true"></i
            ><span>再次上傳</span></label
          >
          <a
            href="javascript:void(0)"
            *ngIf="upload === 1"
            class="btn btn-secondary wd-120 upload_send"
            (click)="uploadFile()"
          >
            <i class="fa fa-cloud-upload" aria-hidden="true"></i
            ><span>開始上傳</span>.
          </a>
        </div>
      <br>
        <!-- 只有有錯誤訊息才顯示這個區塊 -->
        <div *ngIf="uploadErrorMessage" class="alert alert-danger">
          {{ uploadErrorMessage }}
        </div>
        <!-- 顯示成功訊息 -->
        <div *ngIf="uploadSuccessMessage" class="alert alert-success">
          {{ uploadSuccessMessage }}
        </div>
      </div>

      <ng-container *ngFor="let subproject of projectData.projects; let i = index">
        <div class="inndex_box mb-3" *ngIf="detail == false" [ngClass]="{ 'is_done': false }">
          <div class="project_list mb-2">
            <div class="title"><span *ngIf="subproject.is_done">[已完成] </span>{{ subproject.uuid }}</div>
            <div class="file_name">{{ subproject.upload_file_name }}</div>
            <div class="date">
              <div class="name">上傳時間</div>
              <div class="time">
                {{ subproject.created_at | date : "yyyy-MM-dd HH:mm" }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="analyze_bar">
                <div
                  class="bar"
                  [ngClass]="{
                    error: subproject.syncError,
                    done: subproject.syncComplete
                  }"
                  [style.width.%]="
                    subproject.syncPercentage < 20 ? 20 : subproject.syncPercentage
                  "
                >
                  {{ subproject.syncPercentage }}%
                </div>
                <div class="info" *ngIf="subproject.syncError">
                  <div class="info-error">
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    Error 中止原因
                  </div>
                </div>
                <div class="info" *ngIf="subproject.syncError == false">
                  <b>上傳 (A醫院)</b>
                  <i class="fa fa-caret-right" aria-hidden="true"></i>
                  <span>接收 (B醫院)</span>
                </div>
              </div>
            </div>
            <div class="col-auto">
              <div class="btns justify-content-lg-end">
                <a
                  href="javascript:void(0)"
                  (click)="toDetail(subproject)"
                  class="btn btn-primary wd-120"
                  ><i class="fa fa-list-ul" aria-hidden="true"></i
                  ><span>詳細</span></a
                >
                <a
                  [href]="codeUrl + '/code/?CaseID='+subproject.patients[0].serial +'&ProjectID='+subproject.uuid+'&Editor=1'"
                  target="_blank"
                  [ngClass]="{ disabled: !subproject.codeResult }"
                  class="btn btn-secondary wd-120 disabled"
                  ><i class="fa fa-code" aria-hidden="true"></i
                  ><span>CODE結果</span></a
                >
                <a
                  [href]="visualUrl + '/d/be1lpd6dach6o1/aandb-hospital-fhir-dashboard?orgId=1&var-hospital=A hospital FHIR Server&var-hospital=B hospital FHIR Server&refresh=10s'"
                  target="_blank"
                  [ngClass]="{ disabled: !subproject.visualResult }"
                  class="btn btn-secondary wd-120 disabled"
                  ><i class="fa fa-bar-chart" aria-hidden="true"></i
                  ><span>視覺化</span></a
                >
                <a href="#" class="btn btn-stop" *ngIf="subproject.syncComplete ===false"
                  ><i class="fa fa-exclamation-circle" aria-hidden="true"></i
                  ><span>停止</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!--分頁元件 / 列表內頁都可使用-->
      <div class="pager_bar" *ngIf="detail == false">
        <a href="javascript:void(0)" class="arr" *ngIf="min > 1" (click)="gotoPage(1)"
          ><i class="fa fa-angle-double-left" aria-hidden="true"></i
        ></a>
        <a
          *ngFor="let n of pageAry"
          (click)="gotoPage(n)"
          href="javascript:void(0)"
          [ngClass]="n == pageIndex ? 'cur' : ''"
          >{{ n }}</a
        >
        <a
          href="javascript:void(0)"
          class="arr"
          *ngIf="max < pageNumber"
          (click)="gotoPage(pageNumber)"
          ><i class="fa fa-angle-double-right" aria-hidden="true"></i
        ></a>
      </div>

      <!--內頁-->
      <div class="inndex_box" *ngIf="detail">
        <div class="row g-2">
          <div class="col">
            <div class="project_list">
              <div class="row">
                <div class="col">
                  <div class="title">{{ project.uuid }}</div>
                  <div class="file_name">{{ project.upload_file_name }}</div>
                </div>
                <div class="col-auto">
                  <div class="date_inner">
                    <div class="name">上次更新時間</div>
                    <div class="time">
                      {{ projectData.syncTime | date : "yyyy-MM-dd HH:mm" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="btns justify-content-lg-end">
              <a href="javascript:void(0)" (click)="toHome()" class="btn btn-info wd-120"
                ><i class="fa fa-chevron-circle-left" aria-hidden="true"></i
                ><span>返回列表</span></a
              >
              <a
                href="#"
                [href]="codeUrl + '/code/?CaseID='+project.patients[0].serial +'&ProjectID='+project.uuid+'&Editor=1'"
                target="_blank"
                [ngClass]="{ disabled: !project.codeResult }"
                class="btn btn-secondary wd-120"
                ><i class="fa fa-code" aria-hidden="true"></i
                ><span>CODE結果</span></a
              >
              <a
                href="#"
                [href]="visualUrl + '/d/be1lpd6dach6o1/aandb-hospital-fhir-dashboard?orgId=1&var-hospital=A hospital FHIR Server&var-hospital=B hospital FHIR Server&refresh=10s'"
                target="_blank"
                [ngClass]="{ disabled: !project.visualResult }"
                class="btn btn-secondary wd-120"
                ><i class="fa fa-bar-chart" aria-hidden="true"></i
                ><span>視覺化</span></a
              >
            </div>
          </div>
        </div>
        <hr />

        <!--table-->
        <table class="table table-borderless table-striped">
          <thead>
            <tr>
              <td></td>
              <td colspan="6">
                <div class="schedule_bar">
                  <div class="name up">上傳 (A醫院)</div>
                  <div class="bar_box">
                    <div
                      class="bar"
                      [ngClass]="{
                        error: project.syncError,
                        done: project.syncComplete
                      }"
                      [style.width.%]="project.syncPercentage"
                    >
                      {{ project.syncPercentage }}%
                    </div>
                  </div>
                  <div class="name take">接收 (B醫院)</div>
                </div>
              </td>
            </tr>

            <tr>
              <th scope="col"></th>
              <th scope="col">
                <div
                  class="table_title"
                  [ngClass]="{
                    act: project.upload_numAll == 50,
                    done: project.upload_numAll == 100,
                    error: project.upload_numAll == -1
                  }"
                >
                  測試資料解析
                </div>
              </th>
              <th scope="col">
                <div
                  class="table_title"
                  [ngClass]="{
                    act: project.medcat_numAll == 50,
                    done: project.medcat_numAll == 100,
                    error: project.medcat_numAll == -1
                  }"
                >
                  非結構化資料處理
                </div>
              </th>
              <th scope="col">
                <div
                  class="table_title"
                  [ngClass]="{
                    act: project.convert_numAll == 50,
                    done: project.convert_numAll == 100,
                    error: project.convert_numAll == -1
                  }"
                >
                  FHIR格式轉換
                </div>
              </th>
              <th scope="col">
                <div
                  class="table_title"
                  [ngClass]="{
                    act: project.to_a_numAll == 50,
                    done: project.to_a_numAll == 100,
                    error: project.to_a_numAll == -1
                  }"
                >
                  FHIR資料儲存
                </div>
              </th>
              <th scope="col">
                <div
                  class="table_title"
                  [ngClass]="{
                    act: project.validate_numAll == 50,
                    done: project.validate_numAll == 100,
                    error: project.validate_numAll == -1
                  }"
                >
                  FHIR格式檢驗
                </div>
              </th>
              <th scope="col">
                <div
                  class="table_title"
                  [ngClass]="{
                    act: project.to_b_numAll == 50,
                    done: project.to_b_numAll == 100,
                    error: project.to_b_numAll == -1
                  }"
                >
                  FHIR資料傳輸
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of project.projectView">
              <td>{{ data.name }}</td>
              <td>
                <div
                  class="icon"
                  [ngClass]="{
                    act: data.upload == 50,
                    done: data.upload == 100,
                    error: data.upload < 0,
                    all_done: data.upload == 100 && project.upload_numAll == 100
                  }"
                  [ngStyle]="{'width':data.upload == 0 ? '20px' : data.upload+'%'}"
                >
                  <i
                    *ngIf="data.upload > 0 && data.upload < 100"
                    class="fa fa-spinner"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="data.upload == 100"
                    class="fa fa-check"
                    aria-hidden="true"
                  ></i>
                </div>
              </td>
              <td>
                <div
                  class="icon"
                  [ngClass]="{
                    act: data.medcat_num == 50,
                    done: data.medcat_num == 100,
                    error: data.medcat_num < 0,
                    all_done:
                      data.medcat_num == 100 && project.medcat_numAll == 100
                  }"
                  [ngStyle]="{'width':data.medcat_num == 0 ? '20px' : data.medcat_num+'%'}"
                >
                  <i
                    *ngIf="data.medcat_num > 0 && data.medcat_num < 100"
                    class="fa fa-spinner"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="data.medcat_num == 100"
                    class="fa fa-check"
                    aria-hidden="true"
                  ></i>
                </div>
              </td>
              <td>
                <div
                  class="icon"
                  [ngClass]="{
                    act: data.convert_num == 50,
                    done: data.convert_num == 100,
                    error: data.convert_num < 0,
                    all_done:
                      data.convert_num == 100 && project.convert_numAll == 100
                  }"
                  [ngStyle]="{'width':data.convert_num == 0 ? '20px' : data.convert_num+'%'}"
                >
                  <i
                    *ngIf="data.convert_num > 0 && data.convert_num < 100"
                    class="fa fa-spinner"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="data.convert_num == 100"
                    class="fa fa-check"
                    aria-hidden="true"
                  ></i>
                </div>
              </td>
              <td>
                <div
                  class="icon"
                  [ngClass]="{
                    act: data.to_a_num == 50,
                    done: data.to_a_num == 100,
                    error: data.to_a_num < 0,
                    all_done: data.to_a_num == 100 && project.to_a_numAll == 100
                  }"
                  [ngStyle]="{'width':data.to_a_num == 0 ? '20px' : data.to_a_num+'%'}"
                >
                  <i
                    *ngIf="data.to_a_num > 0 && data.to_a_num < 100"
                    class="fa fa-spinner"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="data.to_a_num == 100"
                    class="fa fa-check"
                    aria-hidden="true"
                  ></i>
                </div>
              </td>
              <td>
                <div
                  class="icon"
                  [ngClass]="{
                    act: data.validate_num == 50,
                    done: data.validate_num == 100,
                    error: data.validate_num < 0,
                    all_done:
                      data.validate_num == 100 && project.validate_numAll == 100
                  }"
                  [ngStyle]="{'width':data.validate_num == 0 ? '20px' : data.validate_num+'%'}"
                >
                  <i
                    *ngIf="data.validate_num > 0 && data.validate_num < 100"
                    class="fa fa-spinner"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="data.validate_num == 100"
                    class="fa fa-check"
                    aria-hidden="true"
                  ></i>
                </div>
              </td>
              <td>
                <div
                  class="icon"
                  [ngClass]="{
                    act: data.to_b_num == 50,
                    done: data.to_b_num == 100,
                    error: data.to_b_num < 0,
                    all_done: data.to_b_num == 100 && project.to_b_numAll == 100
                  }"
                  [ngStyle]="{'width':data.to_b_num == 0 ? '20px' : data.to_b_num+'%'}"
                >
                  <i
                    *ngIf="data.to_b_num > 0 && data.to_b_num < 100"
                    class="fa fa-spinner"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="data.to_b_num == 100"
                    class="fa fa-check"
                    aria-hidden="true"
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--內頁 end-->
    </div>
  </div>
  <!--content end-->

  <!--footer-->
  <div id="footer">
    <div class="inner-width">
      <div class="pages-logos">
        <img src="../../../assets/images/mohw_logo.png" class="logomark" alt="" />
        <img src="../../../assets/images/itri_logo.png" class="logomark" alt="" />
        <div class="copyright">Copyright &copy; 2025 SmartEHR Coder</div>
      </div>
    </div>
  </div>
  <!--content end-->
</div>
